// extracted by mini-css-extract-plugin
export default {"table":"TableWrapper_table__1hC3t","collapsed":"TableWrapper_collapsed__YzDpk","groupLabelsRow":"TableWrapper_groupLabelsRow__0aRhP","empty":"TableWrapper_empty__Mz0hY"};